import React from 'react';
import SEO from '../components/SEO';
import './StaticPage.css';

const PrivacyPolicyPage = () => (
  <div className="static-page">
    <SEO
      title="Privacy Policy"
      description="Privacy Policy for SarkariNaukriRajasthan.com – how we collect, use, and protect your information."
      path="/privacy-policy"
    />
    <h1 className="static-page-title">Privacy Policy</h1>
    <p className="static-page-updated">Last updated: March 2, 2026</p>

    <section className="static-section">
      <h2>Introduction</h2>
      <p>
        Welcome to SarkariNaukriRajasthan.com ("we", "our", "us"). We are committed to protecting
        your personal information and your right to privacy. This Privacy Policy explains what
        information we collect, how we use it, and what rights you have in relation to it.
      </p>
      <p>
        By using our website <strong>www.sarkarinaukrirajasthan.com</strong>, you agree to the
        collection and use of information in accordance with this policy.
      </p>
    </section>

    <section className="static-section">
      <h2>Information We Collect</h2>
      <p>We may collect the following types of information:</p>
      <ul>
        <li><strong>Usage Data:</strong> Pages visited, time spent on pages, browser type, device type, IP address, and referring URLs.</li>
        <li><strong>Cookies:</strong> We use cookies to improve your browsing experience and for analytics purposes.</li>
        <li><strong>Google Analytics:</strong> We use Google Analytics to understand how visitors interact with our website. Google Analytics collects information anonymously and reports website trends without identifying individual visitors.</li>
      </ul>
    </section>

    <section className="static-section">
      <h2>How We Use Your Information</h2>
      <ul>
        <li>To provide and maintain our service</li>
        <li>To analyze website traffic and improve our content</li>
        <li>To display relevant advertisements through Google AdSense</li>
        <li>To detect and prevent technical issues</li>
      </ul>
    </section>

    <section className="static-section">
      <h2>Google AdSense & Advertising</h2>
      <p>
        We use Google AdSense to display advertisements on our website. Google AdSense may use
        cookies and web beacons to serve ads based on your prior visits to our website or other
        websites on the internet. Google's use of advertising cookies enables it and its partners
        to serve ads based on your visit to our site and/or other sites on the internet.
      </p>
      <p>
        You may opt out of personalized advertising by visiting{' '}
        <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer">
          Google Ads Settings
        </a>.
      </p>
    </section>

    <section className="static-section">
      <h2>Cookies</h2>
      <p>
        Cookies are small files stored on your device. We use cookies for analytics and advertising
        purposes. You can instruct your browser to refuse all cookies or to indicate when a cookie
        is being sent. However, some features of our website may not function properly without cookies.
      </p>
    </section>

    <section className="static-section">
      <h2>Third-Party Links</h2>
      <p>
        Our website contains links to external websites such as official government job portals and
        application forms. We are not responsible for the privacy practices or content of these
        third-party sites. We encourage you to review the privacy policies of any external sites
        you visit.
      </p>
    </section>

    <section className="static-section">
      <h2>Children's Privacy</h2>
      <p>
        Our website is not intended for children under 13 years of age. We do not knowingly collect
        personal information from children under 13.
      </p>
    </section>

    <section className="static-section">
      <h2>Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Any changes will be posted on this page
        with an updated revision date.
      </p>
    </section>

    <section className="static-section">
      <h2>Contact Us</h2>
      <p>
        If you have any questions about this Privacy Policy, please contact us at:{' '}
        <a href="mailto:sarkarinaukrirajasthanjobs@gmail.com">sarkarinaukrirajasthanjobs@gmail.com</a>
      </p>
    </section>
  </div>
);

export default PrivacyPolicyPage;
